<template>
  <div name="articleFeature">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">編輯推薦</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">話題</li>
              <li class="breadcrumb-item active">編輯推薦</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-article" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10"></div>
          <div class="col-sm-2">
            <button
              type="button"
              @click="sortout()"
              class="btn btn-block btn-default btn-sm sort--save---success"
            >
              <i class="nav-icon fas fa-save fa-sm mr-1"></i> 保存當前排序
            </button>
            <!-- <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              data-toggle="modal"
              data-target="#modal-featured--set"
            >
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增推薦文章
            </button> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="getArticleFeatureModel"
                  border
                  stripe
                  row-key="id"
                  v-loading="isloading"
                >
                  <el-table-column width="30px">
                    <template slot-scope="scope">
                      <i class="fas fa-arrows-alt-v mr-3 handle"></i>
                    </template>
                  </el-table-column>
                  <el-table-column label="推薦文章" width="500px">
                    <template slot-scope="scope">
                       <router-link
                        target="_blank"
                        :title="scope.row.sgL_KMKeyworld"
                        v-bind:to="{
                          name: 'articleview',
                          params: {
                            id: scope.row.id,
                          },
                        }"
                      >
                      <div class="b-article-block mr-2 clearfix">
                        <div class="b-article-thumbnail">
                          <div class="b-article-responsive">
                            <div class="b-article-sizer">
                              <div
                                class="b-article-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + `${scope.row.sgL_ImageUrl}` + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span class="b-title">
                        {{ scope.row.sgL_Title }}
                      </span>
                      
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column label="作者" prop="sgL_DisplayName">
                    <template slot-scope="scope">
                      <el-link type="primary">{{
                        scope.row.sgL_DisplayName
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column label="類型" prop="sgL_MasterSortF">
                    <template slot-scope="scope">
                      <el-link type="primary">{{
                        scope.row.sgL_MasterSortF
                      }}</el-link>
                    </template></el-table-column
                  >
                  <!-- <el-table-column
                    label="加入推薦日期"
                    prop="addTime"
                  ></el-table-column> -->
                  <el-table-column label="狀態">
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.sgL_NStatus == true"
                        class="b-published"
                        >顯示中</span
                      >
                      <span v-else class="b-unpublished">已隱藏</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="瀏覽量"
                    prop="sgL_NViewQuantity"
                  ></el-table-column>
                  <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="UpdateRecommend(scope.row.id, 'remove')"
                        v-if="scope.row.sgL_Recommend == true"
                        >從推薦中移除</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="UpdateRecommend(scope.row.id, 'addstar')"
                        v-else
                        >加入推薦</el-button
                      >

                      <!-- <el-button
                        type="primary"
                        size="mini"
                        @click="editMovie(scope.row.id)"
                        >編輯</el-button
                      > -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>

<script>
import { Message } from "element-ui";
import Sortable from "../../../node_modules/sortablejs";
export default {
  data() {
    return {
      //文章類型
      topicTypeList: [],
      isloading: false,
      ArticleFeatureModel: [],
      filterParam: {
        topicType: "",
      },
    };
  },
  mounted() {
    this.rowDrop(); //用于拖拽排序进来时加载
  },
  created() {
    this.getFeatureArticle();
  },
  methods: {
    getFeatureArticle() {
      let params = {
        Sorting:'DiyCount',
        SGL_Recommend: true, //是否推荐
        SkipCount: 0,
        MaxResultCount: 10,
      };
      this.$api.TopicApi.GetArticleList(params).then((res) => {
        if (res.data.success) {
          this.ArticleFeatureModel = res.data.result.items;
        }
      });
    },
    //加入推荐
    UpdateRecommend(id, func) {
      let params = {
        id: id,
      };
      if (func == "addstar") {
        this.$api.TopicApi.UpdateRecommend(params).then((res) => {
          if (res.data.success) {
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
          } else {
            Message({
              type: "error",
              message: this.$t('message.operationfailure'),
            });
          }
          this.getFeatureArticle();
        });
      } else {
        this.$api.TopicApi.UnUpdateRecommend(params).then((res) => {
          if (res.data.success) {
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
          } else {
            Message({
              type: "error",
              message: this.$t('message.operationfailure'),
            });
          }
          this.getFeatureArticle();
        });
      }
    },
    //保存排序
    sortout() {
      this.sortList = [];
      this.ArticleFeatureModel.map((item, index) => {
        //拖拽时改变了data数据顺序、所以直接取index就可以取到排序值
        let sort = { id: item.id, sortID: index };
        this.sortList.push(sort);
      });
      this.$api.TopicApi.SortAdminTopic(this.sortList).then((res) => {
        if (res.data.success) {
          Message({ type: "success", message: "保存成功" });
        } else {
          Message({ type: "error", message: res.data.error.message });
        }
      });
    },

    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.ArticleFeatureModel.splice(oldIndex, 1)[0]; //删除
          _this.ArticleFeatureModel.splice(newIndex, 0, currRow); //插入
        },
      });
    },
  },
  computed: {
    getArticleFeatureModel() {
      return this.ArticleFeatureModel;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminTopic/TopicRecommend.vue